jQuery('.cute-cuddly').mouseenter(function(){
    jQuery(this).find('.hover-image').toggle(200);
    jQuery(this).find('.stick-image').toggle(200);

})
jQuery( ".cute-cuddly" ).mouseleave(function() {
    jQuery(this).find('.hover-image').toggle(200); 
    jQuery(this).find('.stick-image').toggle(200);
  
})


  

 $(document).ready(function(){
/*code for first video gif*/
     $("#song0").click(function (){
       debugger
       $("#song1_0")[0].play();
     });
  //Plays the file when the mouse is over the element
     $("#song0").mouseover (function (){
       
      $("#song1_0")[0].play();
     });

  //Pause the file when the mouse leaves the element
     $("#song0").mouseleave (function (){
       $("#song1_0")[0].pause();
     });

/*code for second video gif*/
     $("#song1").click(function (e){
       $("#song1_1")[0].play();
     });
  //Plays the file when the mouse is over the element
     $("#song1").mouseover (function (e){
      $("#song1_1")[0].play();
     });

  //Pause the file when the mouse leaves the element
     $("#song1").mouseleave (function (){
       $("#song1_1")[0].pause();
     });   
   
   
/*code for third video gif*/
     $("#song2").click(function (e){
       $("#song1_2")[0].play();
     });
  //Plays the file when the mouse is over the element
     $("#song2").mouseover (function (e){
      $("#song1_2")[0].play();
     });

  //Pause the file when the mouse leaves the element
     $("#song2").mouseleave (function (){
       $("#song1_2")[0].pause();
     });

 /*code for last video gif*/
   $("#song3").click(function (e){
     $("#song1_3")[0].play();
   });
//Plays the file when the mouse is over the element
   $("#song3").mouseover (function (e){
	$("#song1_3")[0].play();
   });

//Pause the file when the mouse leaves the element
   $("#song3").mouseleave (function (){
     $("#song1_3")[0].pause();
   });
        });
// for other link target in newtab
(function () {

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  
  })();



